import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MlfbInformationServiceService {
  constructor(private httpService: HttpClient) {}

  async getMetaDataforMlfb(mlfb: string): Promise<{
    mlfb: string;
    componentType: string;
    description: string;
    gck: string;
    listPrice: number;
  }> {
    const endpoint = `${environment.baseUrl}/product-information/get-meta-information?mlfb=${mlfb}`;

    const options = {
      observe: 'body' as const,
      responseType: 'json' as const
    };

    const result = await this.httpService.get(endpoint, options).toPromise();
    const rawResult = result as any;

    // Handle string listPrice by converting to number or setting to 0
    let listPrice = 0;
    if (typeof rawResult.listPrice === 'number') {
      listPrice = rawResult.listPrice;
    } else if (typeof rawResult.listPrice === 'string') {
      const parsedPrice = parseFloat(rawResult.listPrice);
      listPrice = isNaN(parsedPrice) ? 0 : parsedPrice;
    }

    return {
      mlfb: rawResult.mlfb,
      componentType: rawResult.componentType,
      description: rawResult.description,
      gck: rawResult.gck,
      listPrice: listPrice
    };
  }
}
